import React, { useContext } from "react";
const ApplicationContext = React.createContext();

export const useApplicationContext = () => {
    return useContext(ApplicationContext);
};

export default ApplicationContext;
